{
  "mappings": {
    "title": "Equivalencias de tipos",
    "description": "Cómo se registran en Fermin los tipos que envía {system}. Los que no reconozca se registran como Otro (documentos) o Licencia (ausencias).",
    "documentTitle": "Tipos de documento",
    "absenceTitle": "Tipos de ausencia",
    "caption": "{title}: código de {system} y tipo en Fermin",
    "code": "Código en {system}",
    "target": "En Fermin",
    "default": "Por defecto",
    "custom": "Propio",
    "targetLabel": "Tipo en Fermin para {code}",
    "ignore": "Ignorar",
    "remove": "Quitar",
    "removeLabel": "Quitar {code}",
    "newCode": "Nuevo código",
    "newCodePlaceholder": "Ej.: VAC",
    "newTarget": "Tipo en Fermin",
    "add": "Agregar",
    "save": "Guardar equivalencias",
    "saving": "Guardando…",
    "saved": "Equivalencias guardadas",
    "savedDescription": "Se aplican desde la próxima sincronización.",
    "saveFailed": "No se pudieron guardar las equivalencias",
    "unsaved": "Tienes cambios sin guardar.",
    "errors": {
      "codeRequired": "Escribe el código.",
      "codeTooLong": "Máximo 64 caracteres.",
      "codeDuplicated": "Ese código ya está en la lista.",
      "tooMany": "Máximo {max} equivalencias propias."
    }
  },
  "pending": {
    "title": "Ausencias pendientes en {system}",
    "description": "Aún no están aprobadas en {system}: no justifican faltas hasta que se aprueben y sincronices.",
    "caption": "Ausencias pendientes de aprobación en {system}",
    "worker": "Trabajador",
    "type": "Tipo",
    "dates": "Fechas",
    "updated": "Actualizada",
    "willBe": "Se registrará como {type}",
    "willBeIgnored": "Se ignorará al aprobarse",
    "empty": "No hay ausencias pendientes",
    "emptyDescription": "Cuando {system} tenga ausencias por aprobar, aparecerán aquí.",
    "loadFailed": "No se pudieron cargar las ausencias pendientes",
    "retry": "Reintentar",
    "loadMore": "Cargar más"
  }
}
